/* istanbul ignore file */
import { PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AnalyticsDataPageScreenType } from 'src/types/googleAnalyticsEvents';
import { PageContainer, PageSocialMeta } from 'src/containers';
import { pageWithLayout } from 'src/utils/pageWithLayout';
import { getTargetMessages } from 'src/utils/getTargetMessages';
import BlueBeetlePageContent from '../BlueBeetlePageContent';
import { BlueBeetlePageProps } from '../types/blueBeetlePageProps';
import previewImage from './images/link-preview.png';
import * as localesWithMessages from './messages';

const BlueBeetlePageLayout = ({
  languagePair,
  targetLanguages,
  pageUrlMeta,
  children,
}: PropsWithChildren<BlueBeetlePageProps>) => {
  const intl = useIntl();
  const { targetLanguageLocale } = languagePair;
  const targetMsgs = getTargetMessages(localesWithMessages, targetLanguageLocale);

  const contentMeta = useMemo(
    () => ({
      contentType: AnalyticsDataPageScreenType.campaignRootPage,
      contentName: 'Blue Beetle',
      pageTitle: intl.formatMessage(targetMsgs.title),
      pageDescription: intl.formatMessage(targetMsgs.description),
    }),
    [intl, targetMsgs],
  );

  return (
    <PageContainer
      data-testid="blueBeetleCampaignPage"
      languagePair={languagePair}
      targetLanguages={targetLanguages}
      urlMeta={pageUrlMeta}
      contentMeta={contentMeta}
    >
      <PageSocialMeta
        title={contentMeta.pageTitle}
        description={contentMeta.pageDescription}
        image={previewImage}
      />
      {children}
    </PageContainer>
  );
};

export const BlueBeetlePage = pageWithLayout(BlueBeetlePageLayout, BlueBeetlePageContent);
